module.exports = function(media) {
	'use strict'
	media.directive('newMediaDir',newMediaDir);
	newMediaDir.$inject=[];
	function newMediaDir() {
		return {
			template: require('./partial/new-media.html'),
			controller:"newMediaController",
			controllerAs:"vmnm",
			link: function(scope, element, attrs, ctrl) {
				    
			}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/mediaModule/new-media/js/directive/newMediaDirective.js
// module id = 521
// module chunks = 0